import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import MachineInspectList from './components/MachineInspectList';

const { Cell } = ResponsiveGrid;

const MachineInspect = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="機電巡檢列表"
        // description="機電巡檢"
        breadcrumbs={[
          {
            name: '機電巡檢',
          },
          {
            name: '機電巡檢列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <MachineInspectList />
    </Cell>
  </ResponsiveGrid>
);

export default MachineInspect;
